export const GET_MULTIFILTER_RESULT_API_CALL_START = 'GET_MULTIFILTER_RESULT_API_CALL_START';
export const GET_MULTIFILTER_RESULT_START = 'GET_MULTIFILTER_RESULT_START';
export const GET_MULTIFILTER_RESULT_SUCCESS = 'GET_MULTIFILTER_RESULT_SUCCESS';
export const GET_MULTIFILTER_RESULT_API_CALL_FINISHED = 'GET_MULTIFILTER_RESULT_API_CALL_FINISHED';